<script>
import { mapState } from "vuex"
import { isMobile } from 'mobile-device-detect'
import Placa from '@/components/email/VPlaca'
import Cores from '@/components/email/VCores'
import BtnSalvar from '@/components/email/VBtnSalvar'
import BtnAlterar from '@/components/email/VBtnAlterar'
import Consultar from '@/components/email/VConsultar'

export default {
  name: 'CadastroEmail',
  props: { 
  },
  components: {
    Placa,
    Cores,
    BtnSalvar,
    BtnAlterar,
    Consultar
  },
  data () {
    return {
      isMobile: isMobile,
      idState: null,
      btnAlterarEnable: true,
      btnNovoEnable: true,
      btnCancelarEnable: false,
      btnBuscarEmailVsible: false,
    }
  },
  computed: { 
    ...mapState({
      user: state => state.moduleLogin.user,
      usuario: state => state.moduleLogin.usuario,
      clientinfo: state => state.moduleLogin.clientinfo,
      email: state => state.moduleEmail.email,
    }),
  },
  mounted (){
    
  },
  methods: {
    btnNovo() {
      this.email.estado = 'novo'
      this.btnNovoEnable = false
      this.btnAlterarEnable = false
      this.btnCancelarEnable = true
    },
    btnAlterar() {
      this.email.estado = 'alterar'
      this.btnNovoEnable = false
      this.btnAlterarEnable = false
      this.btnCancelarEnable = true 
    },
    btnCancelar() {
      this.email.estado = ''
      this.btnNovoEnable = true
      this.btnAlterarEnable = true
      this.btnCancelarEnable = false
      this.limparCampos()
    },
    limparCampos(){
      this.email.estado = ''
      this.email.placa = ''
      this.email.cor = 'AMARELA'
      this.email.modelo = ''
      this.email.nome = ''
      this.email.empresa = ''
      this.email.email = ''
      this.email.telefone = 0
      this.btnNovoEnable = true
      this.btnAlterarEnable = true
      this.btnCancelarEnable = false
    }
  },
}
</script>

<template>
  <b-container class="container">
    <div class="textoFiltros">Cadastro Email</div>
    <b-row>
      <b-col cols=12 md="6"> <!-- primeira coluna -->
        <b-row class="text-left" align-v="center">
          <b-col class="separador" cols="12">
            <div>Funções</div>
            <b-row>
              <b-col cols="12">
                <b-button class="separador_botao" :disabled='!btnNovoEnable' @click='btnNovo' :variant="btnNovoEnable ? 'success' : ''">Novo</b-button>
                <b-button class="separador_botao" :disabled='!btnAlterarEnable' @click='btnAlterar' :variant="btnAlterarEnable ? 'warning' : ''">Alterar</b-button>
                <b-button class="separador_botao" :disabled='!btnCancelarEnable' @click='btnCancelar' :variant="btnCancelarEnable ? 'danger' : ''">Cancelar</b-button>
                <Consultar class="separador_botao"/>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="separador" cols="12">
            <div>Veiculos</div>
            <b-row>
              <b-col cols="6">
                <Placa :ativar='btnNovoEnable'/>
              </b-col>
              <b-col cols="6">
                <Cores :ativar='email.estado == "novo_ativo" || email.estado == "alterar_ativo"' />
              </b-col>
              <b-col cols="12">
                <b-form-text>Modelo:</b-form-text>
                <b-form-input class="shadow rounded" v-model="email.modelo" :readonly='!(email.estado == "novo_ativo" || email.estado == "alterar_ativo")'/>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols=12 md="6"> <!-- segunda coluna -->
          <b-row class="text-left" align-v="center">
            <b-col class="separador" cols="12">
              <div>Informações</div>
              <b-row>
                <b-col cols="12">
                  <b-form-text>Nome:</b-form-text>
                  <b-form-input class="shadow rounded" v-model="email.nome" :readonly='!(email.estado == "novo_ativo" || email.estado == "alterar_ativo")'/>
                </b-col>
                <b-col cols="12">
                  <b-form-text>Corporação | Empresa:</b-form-text>
                  <b-form-input class="shadow rounded" v-model="email.empresa" :readonly='!(email.estado == "novo_ativo" || email.estado == "alterar_ativo")'/>
                </b-col>
                <b-col cols="12">
                  <b-form-text>Email:</b-form-text>
                  <b-form-input class="shadow rounded" v-model="email.email" :readonly='!(email.estado == "novo_ativo" || email.estado == "alterar_ativo")'/>
                </b-col>
                <b-col cols="12">
                  <b-form-text>Telefone:</b-form-text>
                  <b-form-input class="shadow rounded" v-model="email.telefone" :readonly='!(email.estado == "novo_ativo" || email.estado == "alterar_ativo")'/>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="separador" cols="12" v-show="email.estado != ''">
              <b-row>
                <b-col cols="12" v-if="(email.estado == 'novo_ativo' || email.estado == 'novo')">
                  <BtnSalvar :ativar='!(email.estado == "novo_ativo" || email.estado == "alterar_ativo")' @limparCampos='limparCampos'/>
                </b-col>
                <b-col cols="12" v-else>
                  <BtnAlterar :ativar='btnAlterarEnable' @limparCampos='limparCampos'/>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped>
  .separador_botao{
    margin-left: 5px;
    margin-top: 5px;
  }
  .separador{
    padding: 15px;
    color: #000000
  }
  .textoFiltros {
    font-weight: bold;
    color: #2c3e50;
    left: 0;
    text-align: left;
    padding-top: 1.5vh;
  }
</style>
